import React from 'react';
import { Redirect } from 'react-router-dom';
import { Spin } from 'm-ui';
import Loadable from 'react-loadable';
import * as Sentry from '@sentry/browser';
import { RouteConfig } from 'react-router-config';

export const loading = (props: { error: any }) => {
    if (props.error) {
        // tslint:disable-next-line
        console.error(props.error);
        Sentry.captureException(props.error);
    }
    return <Spin size="default" style={{ margin: '30% auto', display: 'block' }} />;
};

export const appRoutes: RouteConfig[] = [
    {
        path: '/report',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'report' */ 'modules/report'),
            loading,
        }),
    },
    {
        path: ['/', '/population/manage'],
        exact: true,
        strict: true,
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'MyPopulation' */ 'modules/Market/index'),
            loading,
        }),
    },
    //【主题专区升级】 人群管理 重定向到 人群集市-我的人群
    {
        path: '/population', // 菜单：人群管理
        exact: true,
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'MyPopulation' */ 'modules/Market/index'),
            loading,
        }),
    },
    {
        path: '/report/crowd/chart',
        exact: true,
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'crowd-chart' */ 'modules/crowd-analysis/Chart'),
            loading,
        }),
    },
    {
        path: '/population/tags-area', // 标签专区
        exact: true,
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'tags-area' */ 'modules/TagsAreaNew'),
            loading,
        }),
    },
    {
        path: '/population/upload',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'population-upload' */ 'modules/population/PopulationUpload'
                ),
            loading,
        }),
    },
    {
        path: '/population/portrait', // 菜单：人群画像
        exact: true,
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'population-portrait' */ 'modules/portrait'),
            loading,
        }),
    },
    {
        path: '/population/portrait/chart',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'population-chart' */ 'modules/portrait/PortraitCharts'
                ),
            loading,
        }),
    },
    {
        path: '/population/portrait/compare', // 菜单：人群对比
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'population-chart' */ 'modules/portrait-comparison'),
            loading,
        }),
    },
    {
        path: '/population/create',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'population-create' */ 'modules/PopulationCreate'),
            loading,
        }),
    },
    {
        path: '/population/extend',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'population-extend' */ 'modules/population/PopulationExtend/index'
                ),
            loading,
        }),
    },
    {
        path: ['/population/charged', '/population/tags-area/charged'],
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'population-charged' */ 'modules/population/PopulationCharged/index'
                ),
            loading,
        }),
    },
    //【主题专区升级】 主题专区 重定向到 人群集市-主题专区的行业人群
    {
        path: '/population/theme', // 菜单：主题专区
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'ecom' */ 'modules/Market/IndustryPopulation'),
            loading,
        }),
    },
    // {
    //     path: '/report', // 菜单：投放报表
    //     component: Loadable({
    //         loader: () =>
    //             import(
    //                 /* webpackChunkName: 'TagList' */ 'modules/report/tags-recommend/modules/TagList'
    //             ),
    //         loading,
    //     }),
    // },
    {
        path: '/population/detail',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'detail' */ 'modules/detail'),
            loading,
        }),
    },
    {
        path: '/logic-diagram',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'logic-diagram' */ 'modules/LogicDiagramNew'),
            loading,
        }),
    },
    {
        path: '/split-deduplicate',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'split-deduplicate' */ 'modules/SpiltAndDeduplicate'),
            loading,
        }),
    },
    {
        path: '/message/center',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'message-center' */ 'modules/message-center'),
            loading,
        }),
    },
    {
        path: '/404',
        component: Loadable({
            loader: () => import(/* webpackChunkName: '404' */ 'modules/404'),
            loading,
        }),
    },
    {
        //【主题专区升级】 电商专区 重定向到 人群集市-主题专区的特色专区
        path: '/section/ecom',
        component: () => <Redirect from="/section/ecom" to="/market/special" />,
    },
    {
        path: '/portrait',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'PopulationPortraitV2' */ 'modules/PopulationPortraitV2'
                ),
            loading,
        }),
    },
    {
        path: '/recommend',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'PopulationPortraitV2' */ 'modules/RecommendArea'),
            loading,
        }),
    },

    {
        path: '/policys',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'ecom' */ 'modules/policys'),
            loading,
        }),
    },
    {
        path: '/analysis-center', // 分析中心
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'analysis-center' */ 'modules/analysis-center'),
            loading,
        }),
    },
    {
        path: '/market',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'ecom' */ 'modules/Market'),
            loading,
        }),
    },
    {
        path: '/tools',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'tools' */ 'modules/tools'),
            loading,
        }),
    },
    {
        path: '/crowd-chart',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'crowd-chart' */ 'modules/crowd-analysis/Chart'),
            loading,
        }),
    },
    {
        path: '/feedback',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'feedback' */ 'modules/feedback'),
            loading,
        }),
    },
    // 人群优化
    {
        path: '/population-optimize',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'population-optimize' */ 'modules/PopulationOptimize'),
            loading,
        }),
    },
    {
        path: '*',
        component: () => <Redirect from="/" to="/recommend" />,
    },
];

/**
 * @description 外层route，不经过App.tsx的鉴权逻辑。
 */
const homeRoutes: RouteConfig[] = [
    {
        path: ['/', '/feature'],
        exact: true,
        strict: true,
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'home' */ 'modules/home'),
            loading,
        }),
    },
    {
        path: '/user-agreement',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'user-agreement' */ 'modules/UserAgreement'),
            loading,
        }),
    },
    {
        path: '/account-compass',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'account-compass' */ 'modules/account-compass'),
            loading,
        }),
    },

    {
        path: '*',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'app' */ 'modules/App'),
            loading,
        }),
    },
];

export default homeRoutes;
